__turbopack_context__.v({
  "heading": "Heading-module-scss-module__S7Rh-q__heading",
  "heading1": "Heading-module-scss-module__S7Rh-q__heading1",
  "heading2": "Heading-module-scss-module__S7Rh-q__heading2",
  "heading3": "Heading-module-scss-module__S7Rh-q__heading3",
  "heading4": "Heading-module-scss-module__S7Rh-q__heading4",
  "heading5": "Heading-module-scss-module__S7Rh-q__heading5",
  "heading6": "Heading-module-scss-module__S7Rh-q__heading6",
  "heading7": "Heading-module-scss-module__S7Rh-q__heading7",
  "headingdisplay": "Heading-module-scss-module__S7Rh-q__headingdisplay",
});
